import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import history from '../../history';
import { setDraftStake, updateUserBalanceAction } from '../rootReducer';
import { STATUS } from '../../utils/status';

import firestore from '../../firebase';
import ViewStake from './ViewStake';

class DraftStake extends Component {
  static propTypes = {
    userProfile: PropTypes.object.isRequired,
    draftStake: PropTypes.object
  };

  state = {
    isLoading: false
  }

  // Validate available balance
  confirmStake = () => {
    this.setState({isLoading: true});
    let stake = {...this.props.draftStake};

    if (!this.props.users.some(x => x.user_id === stake.stakee)) {
      this.setState({isLoading: false});
      return;
    }

    if (this.props.availableBalance < stake.amount) return;

    const { sub, nickname, picture } = this.props.userProfile;
    stake.stakerId = sub;
    stake.stakerProfile = { name: nickname, avatar: picture};
    stake.dateCreated = Date.now();
    stake.lastUpdated = stake.dateCreated;
    stake.status = STATUS.Staked;

    
    firestore
    .collection('stakes')
    .add(stake)
    .then(docRef => {
      console.log('Document written with ID: ', docRef.id);
      // Clear the draft stake
      this.props.setDraftStake(null);
      this.props.updateUserBalanceAction(-stake.amount)
      history.push('/');
    })
    .catch(error => {
      console.error('Error adding document: ', error);
      this.setState({isLoading: false});
    });

  };

  render() {
    const { isLoading } = this.state;
    let { userProfile, draftStake } = this.props;

    if (!draftStake) return <Redirect to="/" />;

    return (
      <ViewStake
        user={userProfile}
        stake={draftStake}
        actions={
          <Button fluid primary size="large" loading={isLoading} disabled={isLoading} onClick={this.confirmStake}>
            Stake it
          </Button>
        }
      />
    );
  }
}

const mapStateToProps = ({ auth, app }) => ({
  userProfile: auth.profile,
  draftStake: app.draftStake,
  users: app.users,
  availableBalance: app.availableBalance
});

export default connect(mapStateToProps, { setDraftStake, updateUserBalanceAction })(DraftStake);



// WEBPACK FOOTER //
// ./src/App/ViewStake/DraftStake.js